import { z } from "zod";
import { PromptSurfaceSchema } from "../../enums/prompts";
import { PromptDocumentSchema } from "../../prompts/document";

/**
 * Admin read contracts for prompt bundles. `isActive` is the surface's current
 * selector target; `referenced` is true once any run snapshotted the bundle —
 * either flag freezes it (immutable, undeletable). Bundles are copy-on-write:
 * every edit forks a child with `parentBundleId` lineage.
 */
export const PromptBundleSchema = z.object({
  id: z.uuid(),
  surface: PromptSurfaceSchema,
  key: z.string(),
  label: z.string(),
  parentBundleId: z.uuid().nullable(),
  document: PromptDocumentSchema,
  createdAt: z.coerce.date(),
  isActive: z.boolean(),
  referenced: z.boolean(),
});
export type PromptBundle = z.infer<typeof PromptBundleSchema>;

export const PromptBundleListResponseSchema = z.object({
  bundles: z.array(PromptBundleSchema),
});
export type PromptBundleListResponse = z.infer<
  typeof PromptBundleListResponseSchema
>;
